import { Col, Row, Form, Select, Input, Switch, message } from "antd";
import { useTranslation } from "react-i18next";
import { Option } from "./AddEditSupplier";
import { Dispatch } from "react";

type prop = {
  formatedCurrency: Option[] | undefined;
  formatedContactType: Option[] | undefined;
  setFullName: any;
  setIsFullNameValid: any;
  setFullNameErrorMessage: any;
  setContactType: any;
  fullNameErrorMessage: any;
  setCurrency: Dispatch<any>;
  isEdit: any;
  rest?: any;
  maxLength?: number;
};
function GeneralInformation({
  setFullName,
  setIsFullNameValid,
  setFullNameErrorMessage,
  formatedCurrency,
  formatedContactType,
  fullNameErrorMessage,
  setContactType,
  setCurrency,
  maxLength = 49,
  rest,
  isEdit,
}: prop) {
  const [t] = useTranslation("common");

  const handleFullNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const fullName = event.target.value;
    setFullName(fullName);
    const englishArabicPattern = /^[\p{L}\s]+$/u.test(fullName);
    setIsFullNameValid(englishArabicPattern);
    setFullNameErrorMessage(
      englishArabicPattern
        ? ""
        : "invalid full name format"
    );
    if (fullName.length <= maxLength) {
      if (rest && rest.onChange && typeof rest.onChange === "function") {
        rest.onChange(fullName);
      }
    } else {
      message.warning("Maximum length reached!");
    }
  };

  // const [, setPhoneNumber] = useState("");
  // const [, setErrorMessage] = useState("");
  // const handlePhoneNumberChange = (e: any) => {
  //   const value = e.target.value;

  //   const regex = /^[0-9]*$/; // Updated regular expression
  //   if (regex.test(value)) {
  //     setPhoneNumber(value);
  //     setErrorMessage("");
  //   } else {
  //     setErrorMessage("Please enter numbers only"); // Updated error message
  //   }
  // };

  // const handlePhoneNumberKeyPress = (e: any) => {
  //   const keyCode = e.keyCode || e.which;
  //   const keyValue = String.fromCharCode(keyCode);
  //   const regex = /[0-9.]|\./;

  //   if (!regex.test(keyValue)) {
  //     e.preventDefault();
  //   }

  //   if (keyValue === "." && e.target.value.indexOf(".") !== -1) {
  //     e.preventDefault();
  //   }
  //   if (keyValue === "." && e.target.selectionStart === 0) {
  //     e.preventDefault();
  //   }
  // };
  return (
    <>
      <Row gutter={16}>
        <Col md={6}>
          <Form.Item
            label={`${t("status")}`}
            name="isActive"
            valuePropName="checked"
          >
            <Switch
              checkedChildren={`${t("active")}`}
              unCheckedChildren={`${t("inactive")}`}
              disabled={isEdit() ? false : true}
            />
          </Form.Item>
          <Form.Item
            name="typeId"
            label={`${t("contact-type")}`}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Select
              placeholder={`${t("select-contact-type")}`}
              data-testid="contact-Type"
              showSearch={true}
              optionFilterProp="label"
              options={formatedContactType}
              onChange={(value: any) => setContactType(value)}
            />
          </Form.Item>

          <Form.Item
            name="name"
            label={`${t("fullname")}`}
            rules={[
              {
                required: true,
                message: "full name is required",
              },
            ]}
          >
            <Input
              maxLength={50}
              autoComplete="off"
              data-testid="fullname-input"
              placeholder={`${t("enter-text")}`}
              onChange={handleFullNameChange}
            />
          </Form.Item>
          <span style={{ color: "red" }}> {fullNameErrorMessage}</span>

          <Form.Item name="abbreviation" label={`${t("abbreviation")}`}>
            <Input
              maxLength={20}
              autoComplete="off"
              data-testid="abbreviation-input"
              placeholder={`${t("enter-text")}`}
            />
          </Form.Item>

          <Form.Item
            name="curId"
            label={`${t("currency")}`}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Select
              showSearch={true}
              optionFilterProp="label"
              options={formatedCurrency}
              placeholder={`${t("select-currency")}`}
              onChange={(value: any) => setCurrency(value)}
            />
          </Form.Item>
        </Col>
        <Col md={6}>
          <Form.Item
            label={`${t("status")}`}
            name="isActive"
            valuePropName="checked"
            style={{ visibility: "hidden" }}
          >
            <Switch
              checkedChildren={`${t("active")}`}
              unCheckedChildren={`${t("inactive")}`}
              disabled={isEdit() ? false : true}
            />
          </Form.Item>
          <Form.Item
            name="notes"
            label={`${t("notes")}`}
            style={{ marginLeft: "1rem" }}
          >
            <Input.TextArea
              maxLength={1000}
              autoComplete="off"
              placeholder={`${t("enter-text")}`}
              autoSize={{ minRows: 4, maxRows: 6 }}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
}

export default GeneralInformation;
